import { isStringDirty } from "@suse-o11y/is-string-dirty";
import { FormList, FormUnit, type GetFormInput } from "@suse-o11y/signal/form";
import type { Template } from "@suse-o11y/template";

import { type DashboardMetricsMatchers, dashboardMetricsMatchers } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";

const matcherSchema = dashboardMetricsMatchers.removeCatch().sourceType().element.removeCatch().unwrap();

export type SeriesSelectorState = FormUnit<string, ReadonlyArray<string>, Template<["${", "}"], null>>;

function initSeriesSelectorState(initial: GetFormInput<SeriesSelectorState> = ""): SeriesSelectorState {
	return FormUnit(initial, {
		isInputDirty: isStringDirty,
		schema: matcherSchema,
	});
}

export type FormState = FormList<SeriesSelectorState>;

export const Processor = {
	fromSpec: (matchers = []) =>
		FormList(initSeriesSelectorState, {
			initial: matchers.map((matcher) => matcher.source),
		}),

	toSpec: (matchers) => matchers.slice(),
} satisfies FormProcessor<FormState, undefined | DashboardMetricsMatchers>;
